export const useStyles = theme => ({
    number: {
        float: 'left',
        font: 'normal normal 900 100px Maax-Black',
        verticalAlign: 'top',
        color: '#fff',
        marginRight: '10px'
    },
    descText: {
      font: 'normal normal 16px Maax-Bold',
      color: '#fff',
      marginBottom: '5px'
    },
    tierGrid: {
        padding: 0,
    },
    tierButton: {
        color: '#fff',
        width: '100%',
        minWidth: '20px',
        height: '100px',
        borderColor: '#fff',
        borderRadius: '10px',
        fontSize: '0.8vw',
        padding: '1px',
    },
    tierFull: {
        color: '#0D6A41',
        backgroundColor: '#fff',
        width: '100%',
        minWidth: '20px',
        height: '100px',
        borderColor: '#fff',
        borderRadius: '10px',
        overflowWrap: 'anywhere',
        fontSize: '0.8vw',
        padding: '1px',
    },
    tierArrow: {
        color: '#F0B310',
        marginTop: '35px'
    },
    fullButton: {
        color: '#0D6A41',
        width: '100%',
        height: '50px',
        borderColor: '#fff',
        borderRadius: '10px',
        backgroundColor: '#fff',
    },
    submit: {
        color: '#0D6A41',
        font: 'normal normal 700 25px Maax-Black',
        width: '100%',
        height: '70px',
        borderRadius: '10px',
        borderColor: '#B4C64C',
        backgroundColor: '#B4C64C',
        '&:hover': {
            backgroundColor: '#0D6A41',
            color: '#B4C64C'
        }
    }
})